(function () {
  function dateValue(card) {
    var timestamp = card.dataset.productSdTimestamp;
    if (timestamp && /^-?\d+$/.test(timestamp)) return Number(timestamp) * 1000;
    var value = card.dataset.productSd || '';
    var date = /^\d{4}-\d{2}-\d{2}(?:T.*)?$/.test(value) ? Date.parse(value) : NaN;
    return Number.isFinite(date) ? date : -Infinity;
  }
  function compare(a, b) {
    var dateA = dateValue(a), dateB = dateValue(b);
    if (dateA !== dateB) return dateA > dateB ? -1 : 1;
    // Stable ties preserve Shopify's underlying product order.
    return 0;
  }
  function pageURL(page) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', page);
    return url.pathname + url.search;
  }
  async function initialize(catalog) {
    var currentURL = new URL(window.location.href);
    // An explicitly selected Shopify sorting option takes precedence.
    var selectedSort = currentURL.searchParams.get('sort_by');
    var sortByRelease = !selectedSort || selectedSort === 'relevance' || selectedSort === 'producto-sd-descending';
    var grid = catalog.querySelector('[data-sorted-grid]');
    var pagination = catalog.querySelector('[data-sorted-pagination]');
    var count = catalog.querySelector('[data-product-count]');
    var status = catalog.querySelector('[data-sort-status]');
    var size = Number(catalog.dataset.pageSize) || 16;
    // Shopify already applies explicitly selected native sorts on the server.
    // Leave its HTML and pagination intact instead of downloading the entire catalog.
    if (!sortByRelease) { catalog.dataset.sortState = 'native'; return; }
    if (catalog.dataset.sortState) return;
    catalog.dataset.sortState = 'loading';
    catalog.dataset.sortRequests = '0';
    // Keep server-rendered products and pagination usable during the global sort.
    status.hidden = false;
    status.textContent = 'Actualizando orden por Producto SD…';
    grid.setAttribute('aria-busy', 'true');
    var controller = new AbortController();
    try {
      var initialCards = Array.from(grid.querySelectorAll('[data-product-id]'));
      var excluded = new Set(Array.from(grid.querySelectorAll('[data-excluded-product-id]')).map(function (item) { return item.dataset.excludedProductId; }));
      var total = Number(catalog.dataset.total);
      var complete = catalog.dataset.total !== undefined && initialCards.length + excluded.size === total;
      var cards = complete ? initialCards : [];
      if (!complete) {
        // Use the same active filters/query/market, but render 250 products per request.
        // This is independent of the storefront's 16/24/32-card pagination.
        async function batch(page) {
          var url = new URL(currentURL);
          url.searchParams.delete('sections');
          url.searchParams.delete('view');
          url.searchParams.delete('sort_by');
          url.searchParams.set('section_id', 'catalog-sort-data');
          if (catalog.dataset.themeId) url.searchParams.set('preview_theme_id', catalog.dataset.themeId);
          url.searchParams.set('page', page);
          if (url.pathname.endsWith('/search')) url.searchParams.set('type', 'product');
          catalog.dataset.sortRequests = String(Number(catalog.dataset.sortRequests) + 1);
          var timeout = setTimeout(function () { controller.abort(); }, 30000);
          try {
            var response = await fetch(url.toString(), {signal: controller.signal});
            if (!response.ok) throw new Error('Catalog request failed');
            var parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
            var result = parsed.querySelector('[data-catalog-batch]');
            if (!result || Number(result.dataset.currentPage) !== page) throw new Error('Invalid catalog batch');
            return result;
          } finally { clearTimeout(timeout); }
        }
        var first = await batch(1);
        total = Number(first.dataset.total);
        var pagesToLoad = Number(first.dataset.pages);
        if (!Number.isFinite(total) || !Number.isInteger(pagesToLoad) || pagesToLoad < 0) throw new Error('Invalid catalog size');
        var ids = new Set();
        excluded.clear();
        function collect(batchElement) {
          if (Number(batchElement.dataset.total) !== total) throw new Error('Catalog changed during loading');
          batchElement.querySelectorAll('[data-excluded-product-id]').forEach(function (item) { excluded.add(item.dataset.excludedProductId); });
          batchElement.querySelectorAll('[data-product-id]').forEach(function (card) {
            if (!ids.has(card.dataset.productId)) { ids.add(card.dataset.productId); cards.push(card); }
          });
          status.textContent = 'Actualizando orden por Producto SD… ' + (cards.length + excluded.size) + ' de ' + total;
        }
        collect(first);
        // Bound concurrency to three requests. Consume results in page order so equal
        // dates retain Shopify's underlying stable ordering even if replies race.
        for (var start = 2; start <= pagesToLoad; start += 3) {
          var pending = [];
          for (var page = start; page <= Math.min(start + 2, pagesToLoad); page++) pending.push(batch(page));
          (await Promise.all(pending)).forEach(collect);
        }
      }
      if (Number.isFinite(total) && cards.length + excluded.size !== total) throw new Error('Incomplete catalog results');
      if (sortByRelease) cards.sort(compare);
      var pages = Math.max(1, Math.ceil(cards.length / size));
      function showPage(page) {
        page = Math.min(pages, Math.max(1, Number(page) || 1));
        grid.replaceChildren();
        cards.slice((page - 1) * size, page * size).forEach(function (card) { grid.appendChild(card); });
        if (!cards.length) {
          var empty = document.createElement('p');
          empty.textContent = 'No hay productos que coincidan con estos criterios.';
          grid.appendChild(empty);
        }
        count.textContent = cards.length + ' productos';
        pagination.replaceChildren();
        function link(target, text) {
          var anchor = document.createElement('a');
          anchor.href = pageURL(target);
          anchor.textContent = text;
          anchor.addEventListener('click', function (event) {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
            event.preventDefault();
            window.history.pushState(null, '', anchor.href);
            showPage(target);
            catalog.scrollIntoView({block: 'start'});
          });
          pagination.appendChild(anchor);
        }
        if (page > 1) link(page - 1, 'Anterior');
        if (pages > 1) {
          var label = document.createElement('span');
          label.textContent = ' Página ' + page + ' de ' + pages + ' ';
          pagination.appendChild(label);
        }
        if (page < pages) link(page + 1, 'Siguiente');
      }
      showPage(new URL(window.location.href).searchParams.get('page'));
      catalog.dataset.sortState = 'ready';
      window.addEventListener('popstate', function () { showPage(new URL(window.location.href).searchParams.get('page')); });
      status.hidden = true;
    } catch (error) {
      controller.abort();
      catalog.dataset.sortState = 'error';
      status.textContent = 'Mostrando el orden de Shopify. No se pudo completar el orden por Producto SD.';
      console.warn('Stackerz: Producto SD sorting failed.', error);
    } finally {
      grid.hidden = false;
      grid.removeAttribute('aria-busy');
      pagination.hidden = false;
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-date-catalog]').forEach(initialize);
  });
}());
